<template>
  <el-dialog title="审核" :visible.sync="flag" width="600px">
    <div style="display: flex">
      <div style="font-size: 20px; margin: 10px; width: 90px">审核状态:</div>
      <el-select v-model="value" placeholder="请选择">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </div>
    <div style="display: flex; margin-top: 20px">
      <div style="font-size: 20px; margin: 10px; width: 110px">审核意见:</div>
      <el-input
        type="textarea"
        :maxlength="200"
        show-word-limit
        :rows="6"
        v-model="textarea"
      />
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="flag = false">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { $activity } from "@/services";
export default {
  data() {
    return {
      flag: false,
      schoolInfo: {},
      options: [
        {
          value: 1,
          label: "通过",
        },
        {
          value: 2,
          label: "不通过",
        },
      ],
      textarea: "",
      value: 1,
    };
  },
  methods: {
    setFlag(row) {
      this.schoolInfo = row;
      this.flag = true;
    },
    submit() {
      let params = {};
      params.id = this.schoolInfo.id;
      params.auditStatus = this.value;
      params.auditOpinion = this.textarea;
      console.log(params);
      $activity.audit(params).then((res) => {
        if (res.code === 200) {
          this.$message.success("审核成功");
          this.$parent.getTableList();
          this.flag = false;
        } else {
          this.$message.error("系统错误,请联系管理员");
        }
      });
    },
  },
};
</script>

<style>
.el-form-item__label {
  font-size: 18px;
}
.el-divider__text {
  font-size: 24px;
}
.el-input__inner {
  font-size: 18px;
}
</style>